import React, { FC, PropsWithChildren } from 'react';
import { Empty } from 'antd';

interface EmptyDataProps extends PropsWithChildren {
  hideImage?: boolean;
}

export const EmptyData: FC<EmptyDataProps> = (props) => {
  const { hideImage = false, children } = props;
  return (
    <Empty
      styles={{ image: { display: hideImage ? 'none' : 'block' } }}
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={<strong>{children}</strong>}
    />
  );
};
